// ** UI
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// ** Styles
import GlobalStyling from '@/styles/globalStyles';

// ** Theme
import darkTheme from '@/theme/darkTheme';
import { lightTheme } from '@/theme/lightTheme';

// ** Types
import type React from 'react';
import type { Settings } from '@/types/contextTypes';

const ThemeComponent = ({ children, settings }: { children: React.ReactNode; settings: Settings }) => {
	const theme = createTheme(settings.mode === 'light' ? lightTheme : darkTheme);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<GlobalStyles styles={() => GlobalStyling(theme) as any} />
			{children}
		</ThemeProvider>
	);
};

export default ThemeComponent;
